import field, { Style } from './field';
import type EmailAddressQuestionRecord from './question';

let description: typeof import('./description').default;
let Question: typeof import('./question').default;
let title: (record: EmailAddressQuestionRecord) => Promise<string>;

if (process.env.BROWSER != 'true') {
	Question = require('./question').default;
}

if (process.env.BROWSER != 'true' || process.env.TARGET == 'admin') {
	description = require('./description').default;
	title = async (record: EmailAddressQuestionRecord): Promise<string> => `Email Address: ${record.title}`;
}


export default {
	field,
	style: Style,
	description,
	title,
	isAnswerable: true,
	question: Question
}
